(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEditOnlineLessonTab", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemType/learningItemEditOnlineLessonTabView.html",
            controller: ["messageService", "$scope", "Upload", "$timeout", "$uibModal", "_", LearningItemEditOnlineLessonTabCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditOnlineLessonTabCtrl(messageService, $scope, Upload, $timeout, $uibModal, _) {
            var vm = this;
            $scope.$parent.vm.learningItemResourceObject.$promise.then(function () {
                vm.learningItem = $scope.$parent.vm.learningItem;
            }).catch(angular.noop);
            vm.getLearningItemOnlineLesson = function (id) {
                return _.find(vm.learningItem.learningItemOnlineLessons, { localizationId: id });
            };
            vm.upload = function (file, errFiles, learningItemOnlineLesson) {
                vm.file = file;
                vm.localizationId = learningItemOnlineLesson.localizationId;
                if (errFiles.length > 0) {
                    vm.file = errFiles[0];
                    if (vm.file.$error === "maxSize")
                        messageService.error("common.dropzone.fileTooBigMessage");
                    else if (vm.file.$error === "pattern")
                        messageService.error("common.dropzone.invalidFileTypeMessage");
                    else
                        messageService.error("common.dropzone.generalErrorMessage");
                    return;
                }
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/learningItemOnlineLesson/" + learningItemOnlineLesson.id + "/upload",
                        data: { file: file }
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            _.extend(_.find(vm.learningItem.learningItemOnlineLessons, { id: response.data.id }), response.data);
                            reloadLocalizationRepeater();
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.file.progress = 0;
                        });
                    }, function (response) {
                        if (response.status > 0) {
                            messageService.error(response);
                        }
                        vm.file.progress = 0;
                    }, function (evt) {
                        file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            function reloadLocalizationRepeater() {
                vm.learningItem.enabledLocalizations = angular.copy(vm.learningItem.enabledLocalizations);
            }
            vm.addUpload = function (file, errFiles, localizationId) {
                vm.file = file;
                vm.localizationId = localizationId;
                if (errFiles.length > 0) {
                    vm.file = errFiles[0];
                    if (vm.file.$error === "maxSize")
                        messageService.error("common.dropzone.fileTooBigMessage");
                    else if (vm.file.$error === "pattern")
                        messageService.error("common.dropzone.invalidFileTypeMessage");
                    else
                        messageService.error("common.dropzone.generalErrorMessage");
                    return;
                }
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/learningItemOnlineLesson/addUpload",
                        data: {
                            "learningItemId": vm.learningItem.id,
                            "localizationId": localizationId
                        },
                        file: file
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            vm.learningItem.learningItemOnlineLessons.push(response.data);
                            reloadLocalizationRepeater();
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.file.progress = 0;
                        });
                    }, function (response) {
                        if (response.status > 0) {
                            messageService.error(response);
                        }
                        vm.file.progress = 0;
                    }, function (evt) {
                        file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.openModal = function (learningItemOnlineLesson) {
                var $modalInstance = $uibModal.open({
                    templateUrl: "/app/learningItems/edit/learningItemType/learningItemEditOnlineLessonModalView.html",
                    controller: "LearningItemEditOnlineLessonModalCtrl as vm",
                    resolve: {
                        learningItemOnlineLesson: function () {
                            return angular.copy(learningItemOnlineLesson);
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                    _.extend(_.find(vm.learningItem.learningItemOnlineLessons, { id: result.id }), result);
                    reloadLocalizationRepeater();
                }).catch(angular.noop);
            };
            vm.viewLesson = function (learningItemOnlineLesson) {
                $uibModal.open({
                    templateUrl: "/app/modals/adminOnlineLesson/adminViewOnlineLessonModalView.html",
                    controller: "AdminViewOnlineLessonModalCtrl as vm",
                    resolve: {
                        learningItemOnlineLesson: function () {
                            return angular.copy(learningItemOnlineLesson);
                        }
                    }
                }).result.catch(angular.noop);
            };
        }
    });
})();
